import * as React from 'react';

type Props = {
  src: string;
  title: string;
  className?: string;
};

const IframeEmbed = ({ src, title, className, ...rest }: Props & React.IframeHTMLAttributes<HTMLIFrameElement>) => {
  return <iframe title={title} className={className} src={src} {...rest} />;
};

export default IframeEmbed;
